import { RightOutlined } from '@ant-design/icons';
import { ISection } from '@sdk/contracts';
import { Collapse } from 'antd';
import { useMemo } from 'react';

import { ComplementaryMaterialActivities } from '../ComplementaryMaterialActivities';

import { SectionActions } from '@/components/SectionActions';
import { SectionName } from '@/components/SectionName';
import { useCourseDetail, useCurrentSection, useProfile } from '@/store';

type Props = {
  section: ISection;
};

export const ComplementaryMaterialSectionItem: React.FC<Props> = ({ section }) => {
  const { course } = useCourseDetail();
  const { currentSectionId, setCurrentSectionId } = useCurrentSection();
  const {
    profile,
    roleCheck: { isManager, isTeacher }
  } = useProfile();

  const canRemoveSection = useMemo(
    () =>
      isManager ||
      (isTeacher &&
        profile?._id === section.createdBy._id &&
        !section.activities.some(activity => activity.active) &&
        !section.activities.some(activity => activity.createdBy._id !== profile._id)),
    [isManager, isTeacher, profile, section]
  );

  if (!course) return null;

  return (
    <Collapse
      key={section._id}
      accordion
      activeKey={currentSectionId}
      onChange={key => setCurrentSectionId(key[0])}
      expandIcon={({ isActive }) => <RightOutlined rotate={isActive ? 90 : 0} />}>
      <Collapse.Panel
        key={section._id}
        header={<SectionName section={section} />}
        extra={canRemoveSection && <SectionActions courseId={course._id} section={section} />}>
        <ComplementaryMaterialActivities sectionId={section._id} activities={section.activities} />
      </Collapse.Panel>
    </Collapse>
  );
};
